import { render, staticRenderFns } from "./CaseNew.vue?vue&type=template&id=64bf0dd0"
import script from "./CaseNew.vue?vue&type=script&lang=js"
export * from "./CaseNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports